import React, { FC, Fragment, ReactElement, useState } from "react";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import List from "@material-ui/core/List";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Collapse from "@material-ui/core/Collapse";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import "./menu.scss";
import { useSelector } from "react-redux";
import { AppState } from "./Menu";

const useStyles = makeStyles((theme) => ({
  icon: { minWidth: theme.spacing(5) },
  sidebarIsOpen: {
    paddingLeft: 25,
    transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
  },
  sidebarIsClosed: {
    paddingLeft: 0,
    transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
  },
  menuItem: {
    whiteSpace: "normal",
    color: "#2B3674",
    fontWeight: (isOpen: any) => (isOpen ? 700 : 500),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&:hover": {
      borderRight: "3px solid #127EF1",
    },
  },
  menuLabel: {
    display: "flex",
    alignItems: "center",
  },
}));

interface SubMenuProps {
  icon: ReactElement;
  name: string;
  permissions: string[];
  permissionResources: string[];
}

const SubMenu: FC<SubMenuProps> = ({
  name,
  icon,
  permissions,
  permissionResources,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyles(isOpen);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const isSideBarOpen = useSelector(
    (state: AppState) => state.admin.ui.sidebarOpen
  );

  if (permissions.length === 0) {
    return <></>;
  }

  // Give specific show menu access based on resource
  const findResources = permissions.filter((permission) =>
    permissionResources.includes(permission)
  );
  if (findResources.length === 0) {
    return <></>;
  }

  const header = (
    <MenuItem button onClick={handleToggle} className={classes.menuItem}>
      <div className={classes.menuLabel}>
        <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>
        <span>{name}</span>
      </div>

      {isOpen ? <ExpandLess /> : <ExpandMore />}
    </MenuItem>
  );

  return (
    <Fragment>
      {isOpen ? (
        header
      ) : (
        <Tooltip title={name} placement="right">
          {header}
        </Tooltip>
      )}
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          className={
            isSideBarOpen ? classes.sidebarIsOpen : classes.sidebarIsClosed
          }
        >
          {children}
        </List>
      </Collapse>
    </Fragment>
  );
};

export default SubMenu;
